// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Q8fg","name":"ConsentHeader_name__2oQGQ","birthday":"ConsentHeader_birthday__3WR95","skeleton":"ConsentHeader_skeleton__2yMVr"};